export default function Logo({ size = 28, invert = false, className = '' }) {
  const h = Math.round(size * (303.11 / 293.81));
  const fg = invert ? '#f8faf9' : '#10b981';
  return (
    <svg
      width={size}
      height={h}
      viewBox="0 0 293.81 303.11"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
    >
      <path d="M116.13,139.9l-26.91,46.6c-7.7,13.33-26.94,13.33-34.64,0L2.68,96.6c-3.57-6.19-3.57-13.81,0-20l13.45-23.3c3.57-6.19,10.18-10,17.32-10h26.91c7.15,0,13.75,3.81,17.32,10l38.45,66.6c3.57,6.19,3.57,13.81,0,20Z" fill={fg}/>
      <path d="M133.45,0h26.91c7.15,0,13.75,3.81,17.32,10l13.45,23.3c3.57,6.19,3.57,13.81,0,20l-13.45,23.3c-3.57,6.19-10.18,10-17.32,10h-26.91c-7.15,0-13.75-3.81-17.32-10l-13.45-23.3c-3.57-6.19-3.57-13.81,0-20l13.45-23.3C119.71,3.81,126.31,0,133.45,0Z" fill="#a78bfa"/>
      <path d="M291.13,96.6l-99.67,172.63c-.11.19-.22.39-.33.58l-13.45,23.3c-3.57,6.19-10.17,10-17.32,10h-26.9c-7.15,0-13.75-3.81-17.33-10l-13.45-23.3-13.45-23.3c-7.7-13.33,1.92-30,17.32-30h3.81c7.13,0,13.72-3.79,17.29-9.96.01-.01.02-.03.03-.04l1.91-3.3L216.13,53.3c3.58-6.18,10.18-10,17.33-10h26.9c7.15,0,13.75,3.82,17.32,10l13.45,23.3c3.58,6.19,3.58,13.82,0,20Z" fill={fg}/>
    </svg>
  );
}
